import { render, staticRenderFns } from "./Register030.vue?vue&type=template&id=cf965d88&scoped=true&"
import script from "./Register030.vue?vue&type=script&lang=js&"
export * from "./Register030.vue?vue&type=script&lang=js&"
import style0 from "./Register030.vue?vue&type=style&index=0&id=cf965d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf965d88",
  null
  
)

export default component.exports